export const DialogHeadline = 'text-black'

export const DialogDescriptionTitle =
  'text-16 w-full pt-4 uppercase text-black font-bold'

export const DialogDescriptionContent = 'text-14 leading-24 w-full text-black'

export const DialogButtonsWrapper = 'flex w-full pt-4'

export const ListWrapper = 'flex w-full flex-col py-4'

export const ListItemWrapper =
  'border-machine2-75 group flex w-full items-center border-b px-2 py-4 last-of-type:border-none text-black'

export const ListItemIconWrapper = 'text-mediumGray pr-3'

export const ListItemContentWrapper = 'flex flex-col'

export const ReturnLabelDownloadWrapper = 'flex items-center gap-2'

export const ReturnLabelDownloadText =
  'pl-1 transition duration-200 group-hover:underline'
